import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { Button, Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import CodeEditor from "@uiw/react-textarea-code-editor";
import "../components-css/Code.css";
import func from "@uikit/func";
import BetterLooking from "./BetterLooking";
import publicMethod from "@uikit/publicMethod";
import useHtmlIframe from "@custom-hooks/useHtmlIframe";
import { settings } from "imagica-corekit/dist/base/kernel/Settings";

function Code(props) {
  // const iframeRef = useRef(null)
  /**
   * @type {import('react').MutableRefObject<HTMLDivElement>}
   */
  const codeEditorRef = useRef(null);
  const timers = useRef([]);
  // local state
  const [showDemo, setShowDemo] = useState(false);
  const [demoStr, setDemoStr] = useState("");
  const [codeContent, setCodeContent] = useState({});
  const [showGenerative, setShowGenerative] = useState(false);
  const [loading, setLoading] = useState(false);
  const [fontSizePX, setFontSizePX] = useState(12);

  const focusedThought = useSelector(state => state.feed.focusedThought);
  const disableAddPreview = useSelector(state => state.fot.disableAddPreview);
  const mode = useSelector(state => state.fot.mode);

  const [iframeRef] = useHtmlIframe({
    htmlStr: codeContent.codex_generation,
    deps: [showDemo, showGenerative],
  });

  const projectName = "jerry_beautify_landing_page_demo";

  const handleShowDemo = () => {
    setShowDemo(true);
    setDemoStr(codeContent.codex_generation);
    timers.current.forEach(x => clearTimeout(x));
  };

  const handleShowCodeResult = () => {
    setShowDemo(false);
  };

  const handleClickCard = e => {
    e.stopPropagation();
  };

  const handleClickRefresh = async () => {
    const res = await publicMethod.getUIFromIntelligentAppProject(projectName, focusedThought.thought, setLoading);
    const codeResult = res?.variables?.code_result?.value;
    const description = res?.variables?.description?.value;
    const title = res?.variables?.title?.value;
    if (title && description && codeResult.length > 0) {
      codeResult[0].title = title;
      codeResult[0].description = description;
    }
    if (codeResult) {
      setCodeContent(getFirstHtml(codeResult));
    }
  };

  // const injectHtml = () => {
  //   const iframe = iframeRef.current;
  //   if (!iframe) return;
  //   const content = codeContent.codex_generation;
  //   let iframedoc = iframe.document;
  //   if (iframe.contentDocument)
  //     iframedoc = iframe.contentDocument;
  //   else if (iframe.contentWindow)
  //     iframedoc = iframe.contentWindow.document;

  //   if (iframedoc) {
  //     // Put the content in the iframe
  //     iframedoc.open();
  //     iframedoc.writeln(content);
  //     iframedoc.close();
  //   } else {
  //     //just in case of browsers that don't support the above 3 properties.
  //     //fortunately we don't come across such case so far.
  //     util.messageUtil('Unable to render html code')
  //   }
  // };
  const handleHtmlAnimation = () => {
    const strArr = codeContent.codex_generation.split("\n");

    if (func.isEmpty(codeEditorRef.current)) return;
    const codeEditorEl = codeEditorRef.current.parentNode;
    const codeEditorDivChild = codeEditorEl.children[1];

    for (let index = 0; index < strArr.length; index++) {
      timers.current[index] = setTimeout(() => {
        setDemoStr(preStr => `${preStr}${strArr[index]}\n`);
        codeEditorEl.scrollTo({
          top: codeEditorDivChild.scrollHeight,
        });
      }, 50 * index);
    }
  };

  const gptGenerate = e => {
    e.stopPropagation();
    setShowGenerative(!showGenerative);
  };

  const getFirstHtml = codeObj => {
    let htmlResult = codeObj[0];
    if (mode !== "editorMode") {
      htmlResult = codeObj.find(x => {
        if (typeof x.codex_generation !== "string") return false;
        const code = x.codex_generation.replace("\n/g", "").trim();
        return (
          code.match(/^<!DOCTYPE html>/) ||
          code.match(/^<!doctype html>/) ||
          code.match(/^<html>/) ||
          code.match(/^<body>/) ||
          code.match(/^</)
        );
      });
    }
    const codeContentObj = htmlResult
      ? htmlResult
      : {
          instruction: "Unable to parse codex generation",
          codex_generation: "<html><h1>Unable to parse codex generation</h1></html>",
          title: codeObj[0]?.title,
          description: codeObj[0]?.description,
          notUseAnimation: codeObj[0]?.notUseAnimation || false,
        };
    return codeContentObj;
  };

  useEffect(() => {
    // use first html result
    setCodeContent(getFirstHtml(props.content));
  }, []);
  useEffect(() => {
    switch (props.fontSize) {
      case "Large":
        setFontSizePX(15);
        break;
      default:
        setFontSizePX(12);
    }
  }, [props.fontSize]);

  // html改变需要更新
  useEffect(() => {
    if (func.isEmpty(props.content?.[0]?.codex_generation)) return;
    setCodeContent(getFirstHtml(props.content));
  }, [props.content?.[0]?.codex_generation]);

  useEffect(() => {
    if (!codeContent.codex_generation) return;
    setShowDemo(false);
    if (!codeContent.notUseAnimation) {
      handleHtmlAnimation();
    } else {
      setDemoStr(codeContent.codex_generation);
    }
    return () => timers.current.forEach(x => clearTimeout(x));
  }, [codeContent]);

  useEffect(() => {
    if (props.handleImageLoaded === "function") {
      setTimeout(() => {
        props.handleImageLoaded();
      });
    }
  }, [demoStr]);
  // useEffect(() => {
  //   injectHtml()
  // }, [showDemo]);

  // useEffect(() => {
  //   if(showDemo && !showGenerative) {
  //     injectHtml()
  //   }
  // }, [showGenerative])

  useEffect(() => {
    const editor = codeEditorRef.current;
    if (!editor) {
      return;
    }
    const editorHeight = editor.scrollHeight;
    const editorWidth = editor.scrollWidth;
    const textarea = editor.querySelector("textarea");
    if (!textarea) {
      return;
    }
    textarea.style.height = `${editorHeight}px`;
    textarea.style.width = `${editorWidth}px`;
  }, [codeContent]);

  return (
    <div className="CardHomeCode" onClick={handleClickCard}>
      <Spin spinning={loading} indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} tip="refreshing...">
        <div className="Code">
          {showGenerative ? (
            <BetterLooking codeContent={codeContent} />
          ) : (
            <>
              {showDemo ? (
                <iframe ref={iframeRef} />
              ) : (
                <CodeEditor
                  ref={codeEditorRef}
                  className="CodeEditor"
                  value={demoStr}
                  language="html"
                  disabled
                  padding={15}
                  style={{
                    fontSize: fontSizePX,
                    backgroundColor: "#f5f5f5",
                    fontFamily: "ui-monospace,SF Mono,Consolas,Liberation Mono,Menlo,monospace",
                  }}
                />
              )}

              <footer>
                {showDemo ? (
                  <Button
                    className={disableAddPreview ? "Right-Btn" : "Right-disable-Btn"}
                    disabled={disableAddPreview === false}
                    onClick={handleShowCodeResult}
                  >
                    Code Result
                  </Button>
                ) : (
                  <Button
                    className={disableAddPreview ? "Right-Btn" : "Right-disable-Btn"}
                    disabled={disableAddPreview === false}
                    onClick={handleShowDemo}
                  >
                    Demo
                  </Button>
                )}
                {mode !== "editorMode" ? (
                  <div className="refresh-box refresh-box-code" onClick={handleClickRefresh}>
                    <img src={`${settings.S3CDN}${settings.viewAssetsPath}refresh.svg`} />
                  </div>
                ) : null}
              </footer>
            </>
          )}
        </div>
      </Spin>
      {mode !== "editorMode" ? (
        <div className="Bottom-box">
          {showGenerative ? (
            <Button
              className={disableAddPreview ? "Right-Btn" : "Right-disable-Btn"}
              disabled={disableAddPreview === false}
              onClick={gptGenerate}
              loading={loading}
            >
              Go back
            </Button>
          ) : (
            <Button
              className={disableAddPreview ? "Right-Btn" : "Right-disable-Btn"}
              disabled={disableAddPreview === false}
              onClick={gptGenerate}
              loading={loading}
            >
              Beautify
            </Button>
          )}
        </div>
      ) : null}
    </div>
  );
}

export default Code;
